import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import FormControl from "@mui/material/FormControl";
import { ReactComponent as DropdownIcon } from "../../assets/images/DropdownIcon.svg";
import DialogTitle from "@mui/material/DialogTitle";
import { ReactComponent as ButtonPlus } from "../../assets/images/ButtonPlus.svg";
import {
  Typography,
  Divider,
  Box,
  Tooltip,
  IconButton,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Select,
  MenuItem,
  InputAdornment,
  TextField,
} from "@mui/material";
import { ReactComponent as Plant } from "../../assets/images/Plant.svg";
import { ReactComponent as Setting } from "../../assets/images/Setting.svg";
import { ReactComponent as Date } from "../../assets/images/Date.svg";
import { ReactComponent as User } from "../../assets/images/User.svg";
import { ReactComponent as PartExtension } from "../../assets/images/PartExtension.svg";
import { ReactComponent as CloseIcon } from "../../assets/images/CloseIcon.svg";
import Switch from "@mui/material/Switch";
import CircularProgress from "@mui/material/CircularProgress";
import "../../styles/ownerPartRequest.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { automationHttpRequest } from "../../api/httpRequests";

const OwnerPartRequestDialog = ({
  partRequestNumber,
  open,
  dialogData,
  closeDialog,
  dialogLoading,
  dfDetais,
  fetchPartRequestHistory,
  onRequestStatusUpdate,
}) => {
  const [ownerComment, setOwnerComment] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [loadingReject, setLoadingReject] = React.useState(false);
  const [successPop, setSuccessPop] = useState(false);
  const [inputCount, setInputCount] = useState(1);
  const [inputValues, setInputValues] = useState([""]);
  const [submitButton, setSubmitButton] = useState(false);
  const [justificationShow, setJustificationShow] = useState(false);
  const [justificationShowMin, setJustificationShowMin] = useState(false);
  const [justificationShowMax, setJustificationShowMax] = useState(false);
  const [orderUnit, setOrderUnit] = useState("");
  const [requestID, setRequestID] = useState(0);
  const [leadTimeValue, setLeadTimeValue] = useState("");
  const [netPrice, setNetPrice] = useState("");
  const [vendorNumber, setVendorNumber] = useState("");
  const [vendorMaterialNumber, setVendorMaterialNumber] = useState("");
  const [abcIndicator, setAbcIndicator] = useState({
    abcIndicatorFutureValue: "A : Significant Material",
    abcIndicatorJustify: "",
  });
  const [partCreationDialog, setPartCreationDialog] = useState(false);
  const [currency, setCurrency] = useState("USD");
  const [location, setLocation] = useState("");
  const [criticalityIndicator, setCriticalityIndicator] = useState("");
  const [bin, setBin] = useState("");
  const [minimumValue, setMinimumValue] = useState({
    minimumValueFutureValue: "",
    minimumValueJustify: "",
  });
  const [maximumValue, setMaximumValue] = useState({
    maximumValueFutureValue: "",
    maximumValueJustify: "",
  });
  // const [checked, setChecked] = useState(false)

  const options = ["USD", "CAD", "EUR", "GBP", "JPY"];

  const ABCoptions = [
    "A : Significant Material",
    "B : Medium Significance",
    "C : Low significance",
  ];

  const inputStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "#212F37",
    margin: "0px 20px",
  };
  const handleSelectABCChange = (event) => {
    setAbcIndicator((prevObject) => ({
      ...prevObject,
      abcIndicatorFutureValue: event?.target?.value,
    }));
    setJustificationShow(true);
  };
  const headingStyle = {
    fontWeight: "700",
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 150,
        marginTop: "4px",
        borderRadius: "10px",
        fontFamily: "Verdana",
      },
    },
  };

  const headingStyleComments = {
    fontWeight: "700",
    margin: "10px 10px 10px 0px",
  };
  const uomOptions = [
    "DZ",
    "FT",
    "RL",
    "MIL",
    "M",
    "TH",
    "BOX",
    "DR",
    "BTE",
    "KG",
    "BAG",
    "L",
    "EA",
    "PAK",
    "PAC",
    "GLL",
    "PAA",
    "CS",
    "LB",
    "PAQ",
  ];
  const handleClose = () => {
    setOwnerComment("");
    closeDialog();
  };

  // React.useEffect(()=>{
  //   setOwnerComment("")
  // },[partRequestNumber])

  React.useEffect(() => {
    if (open && dialogData) {
      const extensionComment =
        dialogData?.dataowner_extension_comment ||
        dialogData?.data_owner_extension_comment ||
        dialogData?.dataowner_extention_comment ||
        dialogData?.data_owner_extention_comment ||
        "";
      setOwnerComment(extensionComment);
      setCurrency(dialogData?.currency);
      setLeadTimeValue(dialogData?.lead_time_from_pir?.split(" ")[0]);
      setVendorNumber(dialogData?.vendor_account);
      setVendorMaterialNumber(dialogData?.supplier_part_number);
      setLocation(dialogData?.storage_location);
      setBin(dialogData?.storage_bin);
      setCriticalityIndicator(dialogData?.critical_part);
      setAbcIndicator((prevObject) => ({
        ...prevObject,
        abcIndicatorFutureValue: dialogData?.future_abc_indicator,
      }));
      setMinimumValue((prevObject) => ({
        ...prevObject,
        minimumValueFutureValue:
          parseInt(dialogData?.future_minimum_stock_level) || 0,
      }));
      setMaximumValue((prevObject) => ({
        ...prevObject,
        maximumValueFutureValue:
          parseInt(dialogData?.future_maximum_stock_level) || 0,
      }));
      setNetPrice(dialogData?.standard_price);
      setJustificationShowMax(true);
      setJustificationShow(true);
      setJustificationShowMin(true);
      setAbcIndicator((prevObject) => ({
        ...prevObject,
        abcIndicatorJustify:
          dialogData?.justification_for_change_in_abc_indicator,
      }));
      setMinimumValue((prevObject) => ({
        ...prevObject,
        minimumValueJustify:
          dialogData?.justification_for_change_in_minimum_stock,
      }));
      setMaximumValue((prevObject) => ({
        ...prevObject,
        maximumValueJustify:
          dialogData?.justification_for_change_in_maximum_stock,
      }));
      setInputValues(dialogData?.equipment_number_for_bom);
      setInputCount(dialogData?.equipment_number_for_bom?.length);
      setOrderUnit(dialogData?.order_unit_from_pir || "");
    }
  }, [dialogData]);

  const handleRejectRequest = async () => {
    setLoadingReject(true);
    try {
      const values = {
        request_id: partRequestNumber,
        vendor_account: vendorNumber || dialogData?.vendor_account,
        supplier_part_number:
          vendorMaterialNumber || dialogData?.vendorMaterialNumber,
        lead_time_from_pir:
          leadTimeValue + " " + "Days" || dialogData?.lead_time_from_pir,
        standard_price:
          parseInt(netPrice, 10) ||
          parseInt(dialogData?.standard_price, 10) ||
          0,
        currency: currency || dialogData?.currency,
        order_unit_from_pir: orderUnit || "",
        ABC_indicator: dialogData?.ABC_indicator,
        critical_part: criticalityIndicator || dialogData?.critical_part,
        minimum_stock_level: parseInt(dialogData?.minimum_stock_leve) || 0,
        maximum_stock_level: parseInt(dialogData?.maximum_stock_level) || 0,
        storage_location: location || dialogData?.storage_location,
        storage_bin: bin || dialogData?.storage_bin,
        equipment_number_for_bom:
          inputValues || dialogData?.equipment_number_for_bom,
        future_abc_indicator: abcIndicator?.abcIndicatorFutureValue,
        future_maximum_stock_level:
          parseInt(maximumValue?.maximumValueFutureValue) ||
          parseInt(dialogData?.future_maximum_stock_level) ||
          0,
        future_minimum_stock_level:
          parseInt(minimumValue?.minimumValueFutureValue) ||
          parseInt(dialogData?.future_minimum_stock_level) ||
          0,
        justification_for_change_in_abc_indicator:
          abcIndicator?.abcIndicatorJustify ||
          dialogData?.justification_for_change_in_abc_indicator,
        justification_for_change_in_maximum_stock:
          minimumValue?.minimumValueJustify ||
          dialogData?.justification_for_change_in_maximum_stock,
        justification_for_change_in_minimum_stock:
          maximumValue?.maximumValueJustify ||
          dialogData?.justification_for_change_in_minimum_stock,
        data_owner_extension_comment: ownerComment,
      };
      const response = await automationHttpRequest.post(
        "/extension_reject/",
        { ...values },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {},
        },
      );
      if (response?.data?.status) {
        setLoadingReject(false);
        toast.success(response?.data?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setOwnerComment("");
        onRequestStatusUpdate?.(partRequestNumber, "Rejected");
        closeDialog();
      }
    } catch (error) {
      setLoadingReject(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    }
  };

  const handleChange = (event) => {
    if (event?.target?.name === "leadTime") {
      const numericValue = parseInt(event?.target?.value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setLeadTimeValue(numericValue);
      }
      if (event?.target?.value === "") {
        setLeadTimeValue("");
      }
    } else if (event?.target?.name === "vendorNumber") {
      setVendorNumber(event?.target?.value);
    } else if (event?.target?.name === "vendorMaterialNumber") {
      setVendorMaterialNumber(event?.target?.value);
    } else {
      const isValid = /^[0-9,/.\\-\s]*$/.test(event?.target?.value);
      if (isValid) {
        const numericValue = parseInt(event?.target?.value, 10);
        if (!isNaN(numericValue) && numericValue != "") {
          setNetPrice(event?.target?.value);
        }
        if (event?.target?.value === "") {
          setNetPrice("");
        }
      }
    }
    // setSubmitButton(true);
  };

  const handleFutureValue = (event) => {
    // setSubmitButton(true);
    if (event?.target?.name === "abcIndicator") {
      setAbcIndicator((prevObject) => ({
        ...prevObject,
        abcIndicatorFutureValue: event?.target?.value,
      }));
      setJustificationShow(true);
    }
    if (event?.target?.name === "minimumValue") {
      const numericValue = parseInt(event?.target?.value, 10);
      if ((!isNaN(numericValue) && numericValue != "") || numericValue === 0) {
        setMinimumValue((prevObject) => ({
          ...prevObject,
          minimumValueFutureValue: numericValue,
        }));
        setJustificationShowMin(true);
      }
      if (event?.target?.value === "") {
        setJustificationShowMin(false);
        setMinimumValue((prevObject) => ({
          ...prevObject,
          minimumValueFutureValue: "",
        }));
      }
    }
    if (event?.target?.name === "maximumValue") {
      // if(parseInt(event?.target?.value,10) < parseInt(minimumValue?.minimumValueFutureValue,10) ) {
      //   toast.error("Maximum Stock should be greater than Minimum Stock.", {
      //     position: toast.POSITION.TOP_CENTER,
      //     autoClose: 800,
      //   });
      // }
      if (
        parseInt(event?.target?.value, 10) <
          parseInt(minimumValue?.minimumValueFutureValue, 10) ||
        (parseInt(event?.target?.value, 10) === 0 &&
          parseInt(minimumValue?.minimumValueFutureValue, 10) === 0)
      ) {
        toast.error("Maximum Stock should be greater than Minimum Stock.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
      const numericValue = parseInt(event?.target?.value, 10);
      if ((!isNaN(numericValue) && numericValue != "") || numericValue === 0) {
        setMaximumValue((prevObject) => ({
          ...prevObject,
          maximumValueFutureValue: numericValue,
        }));
        setJustificationShowMax(true);
      }
      if (event?.target?.value === "") {
        setJustificationShowMax(false);
        setMaximumValue((prevObject) => ({
          ...prevObject,
          maximumValueFutureValue: "",
        }));
      }
    }
  };
  const handleJustification = (event) => {
    if (event?.target?.name === "abcIndicator") {
      setAbcIndicator((prevObject) => ({
        ...prevObject,
        abcIndicatorJustify: event?.target?.value,
      }));
    }
    if (event?.target?.name === "minimumValue") {
      setMinimumValue((prevObject) => ({
        ...prevObject,
        minimumValueJustify: event?.target?.value,
      }));
    }
    if (event?.target?.name === "maximumValue") {
      setMaximumValue((prevObject) => ({
        ...prevObject,
        maximumValueJustify: event?.target?.value,
      }));
    }
  };

  const handleIndicatorSelectChange = (event) => {
    // setChecked(!checked)
    let val = event.target.checked ? "X" : "";
    setCriticalityIndicator(val);
    // setCriticalityIndicator(event?.target.value);
  };

  const handleChangeCurrent = (event) => {
    // setSubmitButton(true);
    if (event?.target?.name === "Sloc") {
      setLocation(event?.target.value);
    } else if (event?.target?.name === "CriticalityIndicator") {
      setCriticalityIndicator(event?.target.value);
    } else {
      if (event?.target.value.length <= 10) {
        setBin(event?.target.value);
      } else {
        toast.error("Limit Exceeded.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
    }
  };

  const handleSelectChange = (event) => {
    setCurrency(event?.target?.value);
    // setSubmitButton(true);
  };

  const handleApproveRequest = async () => {
    const values = {
      request_id: partRequestNumber,
      vendor_account: vendorNumber || dialogData?.vendor_account,
      supplier_part_number:
        vendorMaterialNumber || dialogData?.vendorMaterialNumber,
      lead_time_from_pir:
        leadTimeValue + " " + "Days" || dialogData?.lead_time_from_pir,
      standard_price:
        parseInt(netPrice, 10) || parseInt(dialogData?.standard_price, 10) || 0,
      currency: currency || dialogData?.currency,
      order_unit_from_pir: orderUnit || "",
      ABC_indicator: dialogData?.ABC_indicator,
      critical_part: criticalityIndicator || dialogData?.critical_part,
      minimum_stock_level: parseInt(dialogData?.minimum_stock_leve) || 0,
      maximum_stock_level: parseInt(dialogData?.maximum_stock_level) || 0,
      storage_location: location || dialogData?.storage_location,
      storage_bin: bin || dialogData?.storage_bin,
      equipment_number_for_bom:
        inputValues || dialogData?.equipment_number_for_bom,
      future_abc_indicator: abcIndicator?.abcIndicatorFutureValue,
      future_maximum_stock_level:
        parseInt(maximumValue?.maximumValueFutureValue) ||
        parseInt(dialogData?.future_maximum_stock_level) ||
        0,
      future_minimum_stock_level:
        parseInt(minimumValue?.minimumValueFutureValue) ||
        parseInt(dialogData?.future_minimum_stock_level) ||
        0,
      justification_for_change_in_abc_indicator:
        abcIndicator?.abcIndicatorJustify ||
        dialogData?.justification_for_change_in_abc_indicator,
      justification_for_change_in_maximum_stock:
        minimumValue?.minimumValueJustify ||
        dialogData?.justification_for_change_in_maximum_stock,
      justification_for_change_in_minimum_stock:
        maximumValue?.maximumValueJustify ||
        dialogData?.justification_for_change_in_minimum_stock,
      data_owner_extension_comment: ownerComment,
    };
    try {
      setLoading(true);
      const response = await automationHttpRequest.post(
        "/extension_update/",
        { ...values },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {},
        },
      );
      if (response?.data?.status) {
        setLoading(false);
        toast.success(response?.data?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setOwnerComment("");
        onRequestStatusUpdate?.(partRequestNumber, "Approved");
        closeDialog();
      }
    } catch (error) {
      setLoading(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    }
  };

  const ButtonFamily = ({ btnText }) => {
    const isEnabled = ownerComment?.trim()?.length > 0;

    return (
      <>
        <button
          type="submit"
          className="submitButton"
          style={{
            fontSize: 16,
            cursor: "pointer",
            position: "relative",
            fontFamily: "Verdana",
          }}
          onClick={(e) => {
            e.preventDefault();
            if (!ownerComment.trim()) {
              toast.error("Please enter a comment before approving.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 800,
              });
              return;
            }
            handleApproveRequest();
          }}
          disabled={!isEnabled || loading || loadingReject}
        >
          {loading ? (
            // Render loader or loading state here
            <div>Loading...</div>
          ) : (
            // Render button text
            "Approve"
          )}
        </button>
        <button
          type="submit"
          className="submitButton"
          style={{
            fontSize: 16,
            cursor: "pointer",
            position: "relative",
            fontFamily: "Verdana",
          }}
          onClick={(e) => {
            e.preventDefault();
            if (!ownerComment.trim()) {
              toast.error("Please enter a comment before rework.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 800,
              });
              return;
            }
            handleRejectRequest();
          }}
          disabled={!isEnabled || loading || loadingReject}
        >
          {loadingReject ? <div>Loading...</div> : "Rework"}
        </button>
        <button
          type="submit"
          className="submitButton"
          style={{
            fontSize: 16,
            cursor: "pointer",
            position: "relative",
            fontFamily: "Verdana",
          }}
          onClick={(e) => {
            e.preventDefault();
            if (!ownerComment.trim()) {
              toast.error("Please enter a comment before rejecting.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 800,
              });
              return;
            }
            handleRejectRequest();
          }}
          disabled={!isEnabled || loading || loadingReject}
        >
          {loadingReject ? (
            // Render loader or loading state here
            <div>Loading...</div>
          ) : (
            // Render button text
            "Reject"
          )}
        </button>
        <button
          type="submit"
          className="cancelButton"
          style={{
            fontSize: 16,
            cursor: "pointer",
            position: "relative",
            fontFamily: "Verdana",
          }}
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          Cancel
        </button>
      </>
    );
  };

  const handleAddInput = () => {
    setInputCount(inputCount + 1);
    setInputValues([...inputValues, ""]);
    // setSubmitButton(true);
  };

  const handleInputChange = (index, value) => {
    const numericValue = parseInt(value, 10);
    if (!isNaN(numericValue) && numericValue != "") {
      const newInputValues = [...inputValues];
      newInputValues[index] = numericValue;
      setInputValues(newInputValues);
      // setSubmitButton(true);
    }
    if (value === "") {
      const newInputValues = [...inputValues];
      newInputValues[index] = "";
      setInputValues(newInputValues);
    }
  };

  const ValueDisplay = ({
    current,
    suggested,
    future,
    justification,
    currentValue,
    // suggestedValue,
    futureValue,
    justifyValue,
  }) => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
            textAlign: "center",
            // width:"40%"
          }}
        >
          {current && (
            <Typography className="narrowValue" style={headingStyle}>
              {currentValue}
            </Typography>
          )}
          {/* {suggested && (
            <Typography className="narrowValue" style={headingStyle}>
              {suggestedValue}
            </Typography>
          )} */}
          {future && (
            <Typography className="narrowValue" style={headingStyle}>
              {futureValue?.length > 3 ? (
                <Tooltip title={futureValue} arrow>
                  <span>{futureValue?.slice(0, 3) + "..."}</span>
                </Tooltip>
              ) : (
                futureValue
              )}
            </Typography>
          )}
          {justification && (
            <Typography className="narrowValue" style={headingStyle}>
              {justifyValue.length > 8 ? (
                <Tooltip title={justifyValue} arrow>
                  <span>{justifyValue.slice(0, 8) + "..."}</span>
                </Tooltip>
              ) : (
                justifyValue
              )}
            </Typography>
          )}
        </div>
      </>
    );
  };

  const handleOrderUnit = (event) => {
    setOrderUnit(event?.target?.value);
  };

  const StatusLevel = ({ current, suggested, Future }) => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
          }}
        >
          <Typography className="narrowValue" style={headingStyle}>
            {current}
          </Typography>
          <Typography className="narrowValue" style={headingStyle}>
            {suggested}
          </Typography>
          <Typography className="narrowValue" style={headingStyle}>
            {Future}
          </Typography>
        </div>
      </>
    );
  };

  return (
    <>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            maxWidth: "1400px",
            borderRadius: "10px",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="dialogHeading">
            {/* <PartExtension style={{ height: "60px" }} /> */}
            <Typography
              sx={{
                fontFamily: "Verdana",
                fontSize: "24px",
                fontWeight: "600",
              }}
            >
              Part Extension Request
            </Typography>
            <Typography
              sx={{
                fontFamily: "Verdana",
                fontSize: "18px",
                fontWeight: "600",
                // background: "#EFEFEF",
                padding: "6px",
                borderRadius: "4px",
              }}
            >
              Requested ID-{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  marginLeft: "10px",
                }}
              >
                #{partRequestNumber}
              </span>
            </Typography>
          </div>
          <CloseIcon style={{ cursor: "pointer" }} onClick={handleClose} />
        </DialogTitle>
        <DialogContent sx={{ width: "1260px", margin: "10px" }}>
          {dialogLoading ? (
            <>
              <Box sx={{ display: "flex" }}>
                <CircularProgress style={{ color: "#C6003D" }} />
              </Box>
            </>
          ) : (
            <DialogContentText>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  margin: "20px",
                  position: "relative",
                  left: "-60px",
                }}
              >
                <div className="headers">
                  {/* <Setting /> */}
                  <div style={inputStyle}>
                    <Typography>Material Number</Typography>
                    <Typography style={headingStyle}>
                      {dialogData?.material_number || "-"}
                    </Typography>
                  </div>
                </div>
                <div className="headers">
                  {/* <Plant /> */}
                  <div style={inputStyle}>
                    <Typography>Extension Required For Plant</Typography>
                    <Typography style={headingStyle}>
                      {dialogData?.plant_name || "-"}
                    </Typography>
                  </div>
                </div>
                <div className="headers">
                  {/* <User /> */}
                  <div style={inputStyle}>
                    <Typography>Submitted By</Typography>
                    <Typography style={headingStyle}>
                      {dialogData?.submitted_by || "-"}
                    </Typography>
                  </div>
                </div>
                <div className="headers">
                  {/* <Date /> */}
                  <div style={inputStyle}>
                    <Typography>Date of Submission</Typography>
                    <Typography style={headingStyle}>
                      {dialogData?.date_of_submission || "-"}
                    </Typography>
                  </div>
                </div>
              </div>
              <Divider style={{ margin: "20px 0px", background: "#EFEFEF" }} />
              <div
                className="formikExtension"
                style={{
                  width: "100%",
                  justifyContent: "space-around",
                  position: "relative",
                  left: "-60px",
                }}
              >
                {/* <div style={inputStyle}>
                  <Typography style={headingStyle}>
                    SAP Vendor Number
                  </Typography>
                  <Typography style={{ margin: "4px 0px" }}>
                    {dialogData?.vendor_account}
                  </Typography>
                </div>
                <div style={inputStyle}>
                  <Typography style={headingStyle}>
                    Vendor Material Number
                  </Typography>
                  <Typography style={{ margin: "4px 0px" }}>
                    {dialogData?.supplier_part_number}
                  </Typography>
                </div>
                <div style={inputStyle}>
                  <Typography style={headingStyle}>Lead Time</Typography>
                  <Typography style={{ margin: "4px 0px" }}>
                    {dialogData?.lead_time_from_pir}
                  </Typography>
                </div>
                <div style={inputStyle}>
                  <Typography style={headingStyle}>Net Price</Typography>
                  <Typography style={{ margin: "4px 0px" }}>
                    {dialogData?.standard_price + " " + dialogData?.currency ||
                      "-"}
                  </Typography>
                </div>
                <div style={inputStyle}>
                  <Typography style={headingStyle}>Order Unit</Typography>
                  <Typography style={{ margin: "4px 0px" }}>
                    {dialogData?.order_unit_from_pir}
                  </Typography>
                </div> */}
                <div className="formikExtension">
                  <div style={inputStyle}>
                    <Typography style={headingStyle}>
                      SAP Vendor Number
                    </Typography>
                    <input
                      value={vendorNumber}
                      autoComplete="off"
                      // placeholder="Vendor Number"
                      type="text"
                      pattern="[0-9]*"
                      onChange={handleChange}
                      name="vendorNumber"
                      // disabled
                      // style={{ background: "#EFEFEF" }}
                      className="partInputField"
                    />
                  </div>
                  <div style={inputStyle}>
                    <Typography style={headingStyle}>
                      Vendor Material Number
                    </Typography>
                    <input
                      // placeholder="Vendor Material Number"
                      name="vendorMaterialNumber"
                      autoComplete="off"
                      type="text"
                      onChange={handleChange}
                      value={vendorMaterialNumber}
                      className="partInputField"
                      // disabled
                      // style={{ background: "#EFEFEF" }}
                    />
                  </div>
                  <div style={inputStyle}>
                    <Typography
                      style={{
                        fontWeight: "700",
                        position: "relative",
                        left: "10px",
                        fontFamily: "Verdana",
                      }}
                    >
                      Lead Time
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <input
                        // placeholder="Lead Time"
                        name="leadTime"
                        autoComplete="off"
                        onChange={handleChange}
                        type="text" // Change type to text
                        pattern="[0-9]*"
                        inputmode="numeric"
                        value={leadTimeValue}
                        style={{ width: "80px" }}
                        className="partInputField"
                      />
                      <FormControl
                        sx={{
                          m: 1,
                          width: "60px",
                          position: "relative",
                          left: "-10px",
                        }}
                      >
                        <TextField
                          variant="outlined"
                          value={"Days"}
                          // onChange={handleLeadTimeChange}
                          disabled
                          InputProps={{
                            sx: {
                              height: "32px",
                              borderRadius: "8px",
                              backgroundColor: "#f0f0f0", // Set the background color
                              color: "#000", // Set the text color
                              cursor: "not-allowed", // Set the cursor to indicate it's not clickable
                              "&:hover": {
                                backgroundColor: "#f0f0f0", // Adjust hover background color if needed
                              },
                              width: "68px",
                            },
                          }}
                          fullWidth
                        />
                      </FormControl>
                    </div>
                  </div>
                  <div style={inputStyle}>
                    <Typography
                      style={{
                        fontWeight: "700",
                        position: "relative",
                        left: "10px",
                        fontFamily: "Verdana",
                      }}
                    >
                      Price Unit
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <input
                        name="netPrice"
                        onChange={handleChange}
                        type="text" // Change type to text
                        pattern="[0-9,/.\\-\s]*"
                        inputmode="numeric"
                        autoComplete="off"
                        value={netPrice}
                        className="partInputField"
                        style={{ width: "80px" }}
                      />
                    </div>
                  </div>
                  <div style={inputStyle}>
                    <Typography
                      style={{
                        fontWeight: "700",
                        position: "relative",
                        left: "10px",
                        fontFamily: "Verdana",
                      }}
                    >
                      Price UOM
                    </Typography>

                    <FormControl
                      sx={{
                        m: 1,
                        width: "70px",
                        marginTop: "10px",
                        position: "relative",
                        left: "10px",
                      }}
                    >
                      <Select
                        value={currency}
                        onChange={handleSelectChange}
                        IconComponent={() => (
                          <DropdownIcon
                            style={{
                              width: "40px",
                              position: "relative",
                              left: "-10px",
                            }}
                          />
                        )}
                        sx={{
                          height: "32px",
                          borderRadius: "8px",
                          width: "100px",
                        }}
                      >
                        {options.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ ...inputStyle, marginLeft: "10px" }}>
                    <Typography style={headingStyle}>Order UOM</Typography>
                    {/* <input
                        // placeholder="OrderUOM"
                        name="orderUOM"
                        disabled
                        type="text"
                        autoComplete="off"
                        value={dialogData?.order_unit_from_pir}
                        className="partInputField"
                        style={{
                          background: "#EFEFEF",
                          marginLeft: "20px",
                          width: "80px",
                        }}
                      /> */}
                    <FormControl sx={{ m: 1, width: "100px" }}>
                      <Select
                        value={orderUnit}
                        name="orderUOM"
                        onChange={handleOrderUnit}
                        IconComponent={() => (
                          <DropdownIcon
                            style={{
                              width: "30px",
                              position: "relative",
                              left: "-10px",
                            }}
                          />
                        )}
                        MenuProps={MenuProps}
                        sx={{ height: "32px", borderRadius: "8px" }}
                      >
                        {uomOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
              {/* <Divider style={{ background: "#EFEFEF" }} />
              <div className="headings">
                <Typography style={{ color: "black", fontWeight: 600, marginLeft:"50px" }}>
                  Current Value
                </Typography>
             
                <Typography style={{ color: "black", fontWeight: 600 , marginLeft:"50px" }}>
                  Proposed Value
                </Typography>
                <Typography style={{ color: "black", fontWeight: 600 , marginLeft:"45px" }}>
                  Reason for Change
                </Typography>
              </div> */}
              {/* <div className="valueDisplay">
                <Typography className="subHeading">ABC Indicator</Typography>
                <ValueDisplay
                  current={true}
                  suggested={true}
                  future={true}
                  justification={true}
                  currentValue={dialogData?.ABC_indicator}
                  justifyValue={
                    dialogData?.justification_for_change_in_abc_indicator
                      ? dialogData?.justification_for_change_in_abc_indicator
                      : "-"
                  }
                  futureValue={
                    dialogData?.future_abc_indicator
                      ? dialogData?.future_abc_indicator
                      : "-"
                  }
                  // suggestedValue={
                  //   dialogData?.suggested_abc_indicator
                  //     ? dialogData?.suggested_abc_indicator
                  //     : "-"
                  // }
                />
              </div>
              <Divider style={{ background: "#EFEFEF" }} />
              <div className="valueDisplay">
                <Typography className="subHeading">
                  Criticality Indicator
                </Typography>
                <ValueDisplay
                  current={true}
                  suggested={false}
                  future={false}
                  justification={false}
                  currentValue={dialogData?.critical_part}
                />
              </div>
              <Divider style={{ background: "#EFEFEF" }} />
              <div className="valueDisplay">
                <Typography className="subHeading">Minimum Stock</Typography>
                <ValueDisplay
                  current={true}
                  suggested={true}
                  future={true}
                  justification={true}
                  currentValue={dialogData?.minimum_stock_level}
                  justifyValue={
                    dialogData?.justification_for_change_in_minimum_stock
                      ? dialogData?.justification_for_change_in_minimum_stock
                      : "-"
                  }
                  futureValue={
                    dialogData?.future_minimum_stock_level
                      ? dialogData?.future_minimum_stock_level
                      : "-"
                  }
                  // suggestedValue={
                  //   dialogData?.suggested_minimum_stock_level
                  //     ? dialogData?.suggested_minimum_stock_level
                  //     : "-"
                  // }
                />
              </div>
              <Divider style={{ background: "#EFEFEF" }} />
              <div className="valueDisplay">
                <Typography className="subHeading">Maximum Stock</Typography>
                <ValueDisplay
                  current={true}
                  suggested={true}
                  future={true}
                  justification={true}
                  // suggestedValue={
                  //   dialogData?.suggested_maximum_stock_level
                  //     ? dialogData?.suggested_maximum_stock_level
                  //     : "-"
                  // }
                  futureValue={
                    dialogData?.future_maximum_stock_level
                      ? dialogData?.future_maximum_stock_level
                      : "-"
                  }
                  justifyValue={
                    dialogData?.justification_for_change_in_maximum_stock
                      ? dialogData?.justification_for_change_in_maximum_stock
                      : "-"
                  }
                  currentValue={dialogData?.maximum_stock_level}
                />
              </div>
              <Divider style={{ background: "#EFEFEF" }} />
              <div className="valueDisplay">
                <Typography className="subHeading">Storage Location</Typography>
                <ValueDisplay
                  current={true}
                  suggested={false}
                  future={false}
                  justification={false}
                  currentValue={dialogData?.storage_location}
                />
              </div>
              <Divider style={{ background: "#EFEFEF" }} />
              <div className="valueDisplay">
                <Typography className="subHeading">Bin</Typography>
                <ValueDisplay
                  current={true}
                  suggested={false}
                  future={false}
                  justification={false}
                  currentValue={dialogData?.storage_bin}
                />
              </div> */}
              <Divider style={{ background: "#EFEFEF" }} />
              {/* <div>
                <Typography className="equipmentNumber">
                  Equipment Number(s) For BOM
                </Typography>
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "20%",
                    }}
                  >
                    <Typography>
                     
                      {dialogData?.equipment_number_for_bom?.map((val, index) => (
                        <React.Fragment key={index}>
                          {val}
                          <br />
                        </React.Fragment>
                      ))}
                    </Typography>
                  </div>
                </div>
              </div> */}

              <div className="valueDisplay">
                <div className="headings">
                  <Typography
                    style={{
                      color: "black",
                      fontWeight: 600,
                      marginLeft: "60px",
                    }}
                  >
                    Current Value
                  </Typography>

                  <Typography
                    style={{
                      color: "black",
                      fontWeight: 600,
                      marginLeft: "60px",
                    }}
                  >
                    Proposed Value
                  </Typography>
                  <Typography
                    style={{
                      color: "black",
                      fontWeight: 600,
                      marginLeft: "100px",
                    }}
                  >
                    Reason for Change
                  </Typography>
                </div>
                {/* <Typography className="subHeading"></Typography>
                    <Typography
                      style={{
                        fontWeight: 600,
                        fontFamily: "Verdana",
                        margin: "40px 20px 10px 60px",
                      }}
                    >
                      Current Value
                    </Typography>

                    <Typography
                      style={{
                        fontWeight: 600,
                        margin: "40px 20px 10px 35px",
                        fontFamily: "Verdana",
                      }}
                    >
                      Proposed Value
                    </Typography>
                    {
                      <Typography
                        sx={{
                          fontWeight: 600,
                          color: !(
                            justificationShow ||
                            minimumValue?.minimumValueFutureValue > 0 ||
                            maximumValue?.maximumValueFutureValue > 0
                          )
                            ? "#fff"
                            : "#000", // Change color based on justificationShow
                          margin: "40px 20px 10px 110px",
                        }}
                      >
                        Reason for Change
                      </Typography>
                    } */}
              </div>
              <div className="valueDisplay">
                <Typography className="subHeading">ABC Indicator</Typography>

                <ValueDisplay
                  current={true}
                  suggested={true}
                  future={false}
                  disabled={true}
                  justification={false}
                  currentValue={dialogData?.ABC_indicator}
                />
                {/* <input
                      // placeholder="future Value"
                      name="abcIndicator"
                      type="text"
                      className="narrowInput"
                      value={abcIndicator?.abcIndicatorFutureValue}
                      onChange={handleFutureValue}
                    /> */}
                <FormControl
                  sx={{ width: "100px", margin: "0px 20px 0px 70px" }}
                >
                  <Select
                    value={abcIndicator?.abcIndicatorFutureValue}
                    onChange={handleSelectABCChange}
                    IconComponent={() => (
                      <DropdownIcon
                        style={{
                          width: "120px",
                          position: "relative",
                          left: "-10px",
                        }}
                      />
                    )}
                    sx={{ height: "32px" }}
                  >
                    {ABCoptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {justificationShow && (
                  <input
                    // placeholder="Justify Value"
                    name="abcIndicator"
                    autoComplete="off"
                    // disabled={
                    //   abcIndicator?.abcIndicatorFutureValue?.length > 0
                    //     ? false
                    //     : true
                    // }
                    type="text"
                    className="narrowInputReason"
                    value={abcIndicator?.abcIndicatorJustify}
                    onChange={handleJustification}
                  />
                )}
              </div>
              <Divider />
              <div className="valueDisplay">
                <Typography className="subHeading">
                  Criticality Indicator
                </Typography>
                <ValueDisplay
                  current={true}
                  suggested={false}
                  disabled={true}
                  future={false}
                  justification={false}
                  currentValue={dialogData?.critical_part}
                />
                {/* <input
                      // placeholder="Sloc"
                      name="CriticalityIndicator"
                      type="text"
                      autoComplete="off"
                      className="narrowInput"
                      value={criticalityIndicator}
                      onChange={handleChangeCurrent}
                    /> */}

                {/* <FormControl sx={{
                        borderRadius: "8px",
                        margin: "10px 20px 10px 70px !important",
                        width: "100px",
                        outlineStyle: "none",
                        border: "1px solid #cbc3c3",
                        textAlign: "center"
                      }}>
                        <Select
                          value={criticalityIndicator}
                          onChange={handleIndicatorSelectChange}
                          renderValue={(selected) => (
                            <div>
                              <span key={selected}>{selected}</span>
                            </div>
                          )}
                          sx={{
                            padding: "0px !important",
                            height: "32px"
                          }}
                        >
                          <MenuItem value="">
                            <Checkbox checked={criticalityIndicator === ""} />
                            <ListItemText primary="Blank" />
                          </MenuItem>
                          <MenuItem value="X">
                            <Checkbox checked={criticalityIndicator === "X"} />
                            <ListItemText primary="X" />
                          </MenuItem>
                        </Select>
                      </FormControl> */}
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={criticalityIndicator === "X"}
                        style={{
                          color: "#575555",
                          position: "relative",
                          left: "110px",
                        }}
                        onChange={handleIndicatorSelectChange}
                      />
                    }
                    // label="My Checkbox"
                  />
                </FormGroup>
              </div>
              <Divider />
              <div className="valueDisplay">
                <Typography className="subHeading">Minimum Stock</Typography>
                <ValueDisplay
                  current={true}
                  suggested={false}
                  future={false}
                  disabled={true}
                  justification={false}
                  currentValue={dialogData?.minimum_stock_level}
                />
                <input
                  // placeholder="future Value"
                  name="minimumValue"
                  type="text" // Change type to text
                  pattern="[0-9]*"
                  inputmode="numeric"
                  autoComplete="off"
                  className="narrowInput partInputFieldEq"
                  value={
                    parseInt(minimumValue?.minimumValueFutureValue) === 0
                      ? 0
                      : minimumValue?.minimumValueFutureValue
                  }
                  onChange={handleFutureValue}
                />
                {(minimumValue?.minimumValueFutureValue > 0 ||
                  parseInt(minimumValue?.minimumValueFutureValue) === 0) && (
                  <input
                    // placeholder="Justify Value"
                    name="minimumValue"
                    type="text"
                    autoComplete="off"
                    className="narrowInputReason"
                    style={{
                      background:
                        minimumValue?.minimumValueFutureValue > 0 ||
                        parseInt(minimumValue?.minimumValueFutureValue) === 0
                          ? "#FFF"
                          : "#EFEFEF",
                    }}
                    value={minimumValue?.minimumValueJustify}
                    onChange={handleJustification}
                  />
                )}
              </div>
              <Divider />
              <div className="valueDisplay">
                <Typography className="subHeading">Maximum Stock</Typography>
                <ValueDisplay
                  current={true}
                  disabled={true}
                  suggested={false}
                  future={false}
                  justification={false}
                  currentValue={dialogData?.maximum_stock_level}
                />
                <input
                  // placeholder="future Value"
                  name="maximumValue"
                  type="text" // Change type to text
                  pattern="[0-9]*"
                  inputmode="numeric"
                  className="narrowInput partInputFieldEq"
                  autoComplete="off"
                  value={maximumValue?.maximumValueFutureValue}
                  onChange={handleFutureValue}
                />

                {maximumValue?.maximumValueFutureValue > 0 && (
                  <input
                    // placeholder="Justify Value"
                    name="maximumValue"
                    type="text"
                    autoComplete="off"
                    className="narrowInputReason"
                    style={{
                      background:
                        maximumValue?.maximumValueFutureValue > 0
                          ? "#FFF"
                          : "#EFEFEF",
                    }}
                    value={maximumValue?.maximumValueJustify}
                    onChange={handleJustification}
                  />
                )}
              </div>
              <Divider />
              <div className="valueDisplay">
                <Typography className="subHeading">Storage Location</Typography>
                <ValueDisplay
                  current={true}
                  disabled={true}
                  suggested={false}
                  future={false}
                  justification={false}
                  currentValue={dialogData?.storage_location}
                />
                <input
                  // placeholder="Sloc"
                  name="Sloc"
                  type="text"
                  className="narrowInput"
                  autoComplete="off"
                  value={location}
                  onChange={handleChangeCurrent}
                />
              </div>
              <Divider />
              <div className="valueDisplay">
                <Typography className="subHeading">Bin</Typography>
                <ValueDisplay
                  current={true}
                  disabled={true}
                  suggested={false}
                  future={false}
                  justification={false}
                  currentValue={dialogData?.storage_bin}
                />
                <input
                  // placeholder="Bin"
                  name="Bin"
                  type="text"
                  className="narrowInput"
                  autoComplete="off"
                  value={bin}
                  onChange={handleChangeCurrent}
                />
              </div>
              <Divider />

              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Verdana",

                  margin: "20px 0px 0px 0px",
                  fontWeight: "700",
                  position: "relative",
                  // left: "10px",
                  fontFamily: "Verdana",
                }}
              >
                Equipment Number(s) For BOM
                <span
                  style={{
                    color: "#C6003D",
                    margin: "4px",
                    fontSize: "18px",
                  }}
                >
                  *
                </span>
              </Typography>
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "24.7%",
                  }}
                >
                  {Array.from({ length: inputCount }).map((_, index) => (
                    <input
                      key={index}
                      className="partInputFieldEq"
                      type="text" // Change type to text
                      pattern="[0-9]*"
                      inputmode="numeric"
                      autoComplete="off"
                      value={inputValues[index]}
                      onChange={(e) => handleInputChange(index, e.target.value)}
                      minLength="0" // Change min to minLength
                      maxLength="10" // Assuming you want to limit the length of input
                    />
                  ))}
                </div>
                <IconButton onClick={handleAddInput} sx={{ height: "40px" }}>
                  <ButtonPlus />
                </IconButton>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  color: "#212F37",
                }}
              >
                <Typography style={headingStyleComments}>
                  Comments
                  <span
                    style={{
                      color: "#C6003D",
                      margin: "4px",
                      fontSize: "18px",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <textarea
                  id="yourTextarea"
                  name="yourTextarea"
                  placeholder="Enter Comments"
                  value={
                    ownerComment ||
                    dialogData?.dataowner_extension_comment ||
                    dialogData?.data_owner_extension_comment ||
                    dialogData?.dataowner_extention_comment ||
                    dialogData?.data_owner_extention_comment ||
                    ""
                  }
                  style={{
                    width: "50%",
                    fontFamily: "Verdana", // Set the font family to Verdana
                    minHeight: "50px",
                  }}
                  onChange={(e) => setOwnerComment(e?.target?.value)}
                  className="partTextField"
                  rows={4}
                  cols={50}
                />
              </div>
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            margin: "auto !important",
            // justifyContent: "flex-start !important",
          }}
        >
          <ButtonFamily btnText="Approve" />
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </>
  );
};

export default OwnerPartRequestDialog;
